export default "__VITE_ASSET__08d25884__"